import { render, staticRenderFns } from "./DonorMatchingModalComp.vue?vue&type=template&id=77c0c756&scoped=true"
import script from "./DonorMatchingModalComp.vue?vue&type=script&lang=js"
export * from "./DonorMatchingModalComp.vue?vue&type=script&lang=js"
import style0 from "./DonorMatchingModalComp.vue?vue&type=style&index=0&id=77c0c756&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c0c756",
  null
  
)

export default component.exports